import { render, staticRenderFns } from "./Personas.vue?vue&type=template&id=9145bacc&"
import script from "./Personas.vue?vue&type=script&lang=js&"
export * from "./Personas.vue?vue&type=script&lang=js&"
import style0 from "./Personas.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports